import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import ConditionalComponent from "../../Shared/ConditionalComponent";
import {guidesUploadStore, modalStore, projectStore} from "../../../index";
import LinearLoader from "../../Shared/LinearLoader";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ErrorIcon from '@mui/icons-material/Error';

const UploadGuideToastModal = observer(() => {
    const [isManuallyClosed, setIsManuallyClosed] = useState(false)
    const [isCanceld, setisCanceld] = useState(false)
    const handleClose = ()=>{
        setIsManuallyClosed(true)
        guidesUploadStore.closeProcess()
    }
    const closeButton = ()=>{
        return (<CloseOutlinedIcon style={{ color: 'var(--main-normal-color)', cursor: 'pointer'}}  fontSize="small" onClick={handleClose}/>)
    }
    useEffect(()=>{
        if (guidesUploadStore.isFailedOrCanceledProgress){
            setisCanceld(true)
        }
    },[guidesUploadStore.isFailedOrCanceledProgress])

    useEffect(() => {
        setIsManuallyClosed(false)
    }, [projectStore.currentProjectId]);
    useEffect(() => {
       if (!modalStore.isUploadProcedureModalOpen){
           setIsManuallyClosed(false)
       }
    }, [modalStore.isUploadProcedureModalOpen]);
    useEffect(() => {
        if (!guidesUploadStore.isLoading){
            setisCanceld(false)
        }
    }, [guidesUploadStore.isLoading]);

    useEffect(() => {
        if (!(guidesUploadStore.isLoading && guidesUploadStore.linearLoaderValue < 10) || isCanceld) return;
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [guidesUploadStore.isLoading,  guidesUploadStore.linearLoaderValue]);
    return (
        <>
            <ConditionalComponent if={!modalStore.isUploadProcedureModalOpen && !isManuallyClosed && guidesUploadStore.isLoading}>
                <div className="absolute bottom-2 right-2 font-sans"  style={{
                    zIndex: 2000,
                    display: 'flex',
                    width: '380px',
                    padding: '16px',
                    flexDirection: 'column',
                    gap: '16px',
                    borderRadius: '10px',
                    border: '1px solid var(--Navigation-bar-Navigation-bar-Normal, #C2C9DB)',
                    background: 'var(--Windows-and-menus-Windows-and-menus-Normal, #FFF)',
                    boxShadow: '0 4px 25.2px 0 rgba(0, 0, 0, 0.25)',
                }}>
                    <ConditionalComponent if={guidesUploadStore.linearLoaderValue < 100 && !isManuallyClosed && !isCanceld}>
                        <div className="flex flex-col text-main-normal w-full items-start">
                            <div className="flex flex-row justify-between items-center w-full">
                                <div className="font-bold">Migrating files {guidesUploadStore.finishedFilesCount}/{guidesUploadStore.notCanceledFilesCount}</div>
                                {closeButton()}
                            </div>
                            <div className="text-sm mb-3">Please wait for the process to finish</div>
                            <LinearLoader value={guidesUploadStore.linearLoaderValue}/>
                            <div className="text-sm flex flex-row justify-between w-full mt-2">
                                <div className="text-leavedeletenew-normal cursor-pointer" onClick={async()=>{
                                    setisCanceld(true)
                                    await guidesUploadStore.cancelUploadingAll()
                                }}>Cancel</div>
                                <div className="flex flex-row gap-4">
                                    <div className="text-link-normal cursor-pointer" onClick={()=>modalStore.isUploadProcedureModalOpen=true}>Details</div>
                                    <div>{guidesUploadStore.linearLoaderValue}%</div>
                                </div>

                            </div>
                        </div>
                    </ConditionalComponent>
                    <ConditionalComponent if={isCanceld && !isManuallyClosed}>
                        <div className="flex flex-row text-main-normal w-full items-center justify-between">
                            <div className="flex flex-row text-main-normal items-center gap-2">
                                <CancelIcon
                                    style={{ color: 'var(--leavedeletenew-normal-color)' }}
                                />
                                <div className="font-bold">Migration process failed</div>
                            </div>
                            <div className="text-link-normal cursor-pointer" onClick={()=>modalStore.isUploadProcedureModalOpen=true}>Details</div>
                            {closeButton()}
                        </div>
                    </ConditionalComponent>
                </div>
            </ConditionalComponent>
            <ConditionalComponent if={!modalStore.isUploadProcedureModalOpen && guidesUploadStore.isSuccess && !isManuallyClosed}>
                <div className="absolute bottom-2 right-2 font-sans"  style={{
                    zIndex: 2000,
                    display: 'flex',
                    width: '380px',
                    padding: '16px',
                    flexDirection: 'column',
                    gap: '16px',
                    borderRadius: '10px',
                    border: '1px solid var(--Navigation-bar-Navigation-bar-Normal, #C2C9DB)',
                    background: 'var(--Windows-and-menus-Windows-and-menus-Normal, #FFF)',
                    boxShadow: '0 4px 25.2px 0 rgba(0, 0, 0, 0.25)',
                }}>
                    <div className="flex flex-row text-main-normal w-full items-center justify-between">
                        <div className="flex flex-row text-main-normal items-center gap-2">
                            {guidesUploadStore.finishedFilesCount === guidesUploadStore.notCanceledFilesCount && <CheckCircleIcon
                                style={{ color: 'var(--onlinesuccess-normal-color)' }}
                            />}
                            {guidesUploadStore.finishedFilesCount < guidesUploadStore.notCanceledFilesCount && <ErrorIcon
                                style={{ color: '#FFAE42' }}
                            />}
                            <div className="font-bold">{guidesUploadStore.finishedFilesCount}/{guidesUploadStore.notCanceledFilesCount} Files migrated successfully</div>
                        </div>
                        <div className="text-link-normal cursor-pointer" onClick={()=>modalStore.isUploadProcedureModalOpen=true}>Details</div>
                        {closeButton()}
                    </div>
                </div>
            </ConditionalComponent>
        </>
    )
});

export default UploadGuideToastModal